import { gql } from "@apollo/client";

export const SAVE_SURVEY_CATEGORY = gql`
  mutation ($categorySurvey: String!, $userCreateCategorySurvey: String!) {
    createCategorySurvey(
      categorySurvey: $categorySurvey
      userCreateCategorySurvey: $userCreateCategorySurvey
    ) {
      withError
      message
      outputData {
        idCategorySurvey
        categoryDescription
        recordState
        createUser
        createDate
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;

export const SAVE_QUESTION_CATEGORY = gql`
  mutation ($categoryQuestion: String, $userCreateCategory: String!) {
    createCategoryQuestion(
      categoryQuestion: $categoryQuestion
      userCreateCategory: $userCreateCategory
    ) {
      withError
      message
      outputData {
        idCategoryQuestion
        description
        recordState
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;

export const CREATE_SURVEY = gql`
  mutation (
    $surveyName: String!
    $surveyDescription: String!
    $idCategorySurvey: Int!
    $createUser: String!
    $countryId: Int!
    $isAnonymous: Boolean
    $isGlobal: Boolean
    $clientTpCodes: [Int!]
    $integrationTpclient: Boolean!
  ) {
    createSurvey(
      surveyModel: {
        surveyName: $surveyName
        surveyDescription: $surveyDescription
        createUser: $createUser
        idCategorySurvey: $idCategorySurvey
        countryId: $countryId
        isAnonymous: $isAnonymous
        isGlobal: $isGlobal
        clientTpCodes: $clientTpCodes
        integrationTpclient: $integrationTpclient
      }
    )
  }
`;

export const CREATE_FORM_AS_SURVEY = gql`
  mutation (
    $surveyName: String!
    $surveyDescription: String!
    $idCategorySurvey: Int!
    $createUser: String!
    $integrationTpclient: Boolean!
    $countryId: Int!
  ) {
    createForm(
      formModel: {
        surveyName: $surveyName
        surveyDescription: $surveyDescription
        createUser: $createUser
        idCategorySurvey: $idCategorySurvey
        integrationTpclient: $integrationTpclient
        countryId: $countryId
      }
    ) {
      idSurvey
      numberCaseTpClient
    }
  }
`;

export const CREATE_QUESTION_BANK = gql`
  mutation (
    $nameQuestion: String!
    $validationText: String!
    $idCategoryQuestion: Int!
    $active: Boolean!
    $createUser: String!
  ) {
    createQuestionBank(
      questionBankModel: {
        nameQuestion: $nameQuestion
        validationText: $validationText
        idCategoryQuestion: $idCategoryQuestion
        active: $active
        createUser: $createUser
      }
    )
  }
`;

export const CREATE_QUESTION_SURVEY = gql`
  mutation (
    $idSurvey: Int!
    $idQuestion: Int!
    $jsonConfiguration: String!
    $order: Int!
    $isMandatory: Boolean!
    $active: Boolean!
    $createUser: String!
  ) {
    createQuestionSurvey(
      questionSurveyModel: {
        idQuestion: $idQuestion
        idSurvey: $idSurvey
        jsonConfiguration: $jsonConfiguration
        isMandatory: $isMandatory
        order: $order
        active: $active
        createUser: $createUser
      }
    )
  }
`;

export const UPDATE_QUESTION_BANK = gql`
  mutation (
    $idQuestion: Int!
    $nameQuestion: String
    $validationText: String
    $idCategoryQuestion: Int
    $active: Boolean
    $lastUpdateUser: String!
  ) {
    updateQuestionBank(
      questionBankModel: {
        idQuestion: $idQuestion
        nameQuestion: $nameQuestion
        validationText: $validationText
        idCategoryQuestion: $idCategoryQuestion
        active: $active
        lastUpdateUser: $lastUpdateUser
      }
    )
  }
`;

export const UPDATE_QUESTION_SURVEY = gql`
  mutation (
    $idQuestionSurvey: Int!
    $idSurvey: Int
    $idQuestion: Int!
    $jsonConfiguration: String
    $order: Int
    $isMandatory: Boolean
    $active: Boolean!
    $lastUpdateUser: String!
  ) {
    updateQuestionSurvey(
      questionSurveyModel: {
        idQuestionSurvey: $idQuestionSurvey
        idQuestion: $idQuestion
        idSurvey: $idSurvey
        jsonConfiguration: $jsonConfiguration
        isMandatory: $isMandatory
        order: $order
        active: $active
        lastUpdateUser: $lastUpdateUser
      }
    )
  }
`;

export const ADD_TPCL_TREE_BRANCH = gql`
  mutation (
    $nameL1_BRAN: String!
    $father_Id_BRAN: String
    $createUser: String!
  ) {
    createBranch(
      childBranch: {
        id_BRAN: ""
        nameL1_BRAN: $nameL1_BRAN
        order_BRAN: 0
        isActive_BRAN: true
        isVisible_BRAN: true
        father_Id_BRAN: $father_Id_BRAN
        login: $createUser
      }
    )
  }
`;

export const CREATE_ANSWER_QUESTION_SURVEY = gql`
  mutation (
    $idQuestionSurvey: Int!
    $idCategoryAnswer: Int!
    $createUser: String!
  ) {
    createAnswerQuestionSurvey(
      answerQuestionSurveyModel: {
        idQuestionSurvey: $idQuestionSurvey
        idCategoryAnswer: $idCategoryAnswer
        jsonConfiguration: ""
        createUser: $createUser
      }
    )
  }
`;

export const CREATE_CONFIGURATION_SURVEY = gql`
  mutation (
    $idSurvey: Int!
    $field: String!
    $jsonConfiguration: String!
    $createUser: String!
  ) {
    saveConfigurationSurvey(
      configurationSurveyModel: {
        idSurvey: $idSurvey
        field: $field
        jsonConfiguration: $jsonConfiguration
        createUser: $createUser
      }
    )
  }
`;

export const UPDATE_CONFIGURATION_SURVEY = gql`
  mutation (
    $idConfigurationSurvey: Int!
    $idSurvey: Int!
    $field: String!
    $jsonConfiguration: String!
    $createUser: String!
  ) {
    updateConfigurationSurvey(
      configurationSurveyModel: {
        idSurvey: $idSurvey
        field: $field
        jsonConfiguration: $jsonConfiguration
        createUser: $createUser
      }
    )
  }
`;

export const SAVE_ANSWERS_SURVEY_AGENT = gql`
  mutation (
    $idSurvey: Int!
    $openSurveyDate: String!
    $sentSurveyDate: String!
    $userId: Int!
    $idSurveyScheduling: Int
    $isAnonymous: Boolean!
    $answerClients: [AddTpSurveyAnswerClientInput!]!
  ) {
    saveAnswersSurvey(
      input: {
        idSurvey: $idSurvey
        openSurveyDate: $openSurveyDate
        sentSurveyDate: $sentSurveyDate
        userId: $userId
        idSurveyScheduling: $idSurveyScheduling
        answerClients: $answerClients
        isAnonymous: $isAnonymous
      }
    ) {
      success
      message
      anonymousSurveyId
    }
  }
`;

export const ENCRIPT_PARAMETERS = gql`
  mutation ($idSurvey: String!) {
    encriptParameters(paramToken: { idSurvey: $idSurvey })
  }
`;

export const CREATE_SURVEY_TPCLIENT = gql`
  mutation ($idSurvey: Int!) {
    createConfigurationSurveyTPClient(survey: { idSurvey: $idSurvey })
  }
`;

export const DECRIPT_PARAMETERS = gql`
  mutation ($Token: String) {
    decriptParameters(paramToken: $Token)
  }
`;

export const SAVE_SURVEY_TP = gql`
  mutation ($data: String!) {
    createSurveyTPClient(data: $data)
  }
`;

export const UPDATE_SURVEY_TP = gql`
  mutation (
    $idSurvey: Int!
    $idSurveyState: Int!
    $User: String!
    $activateUser: String!
    $activateDate: DateTime
  ) {
    updateSurvey(
      surveyModel: {
        idSurvey: $idSurvey
        idSurveyState: $idSurveyState
        lastUpdateUser: $User
        activateSurveyUser: $activateUser
        activateSurveyDate: $activateDate
      }
    ) {
      message
      outputData {
        idSurvey
        idSurveyState
        lastUpdateUser
        activateSurveyUser
        activateSurveyDate
      }
      withError
    }
  }
`;

export const CHANGE_STATE_SURVEY = gql`
  mutation ($idSurvey: Int!, $newSurveyState: SurveyState!) {
    changeStateSurvey(idSurvey: $idSurvey, newSurveyState: $newSurveyState) {
      withError
      message
      outputData {
        idSurvey
        surveyName
        idSurveyState
      }
    }
  }
`;

export const CHANGE_STATE_FORM = gql`
  mutation ($idForm: Int!, $newFormState: SurveyState!) {
    changeStateForm(idForm: $idForm, newFormState: $newFormState) {
      withError
      message
      outputData {
        idSurvey
        surveyName
        idSurveyState
      }
    }
  }
`;

export const UPDATE_NAME_DESCRIPTION_SURVEY_TP = gql`
  mutation (
    $idSurvey: Int!
    $surveyName: String!
    $surveyDescription: String!
    $isAnonymous: Boolean
    $setRandomQuestions: Boolean
    $lastUpdateUser: String!
  ) {
    updateSurvey(
      surveyModel: {
        idSurvey: $idSurvey
        surveyName: $surveyName
        surveyDescription: $surveyDescription
        isAnonymous: $isAnonymous
        setRandomQuestions: $setRandomQuestions
        lastUpdateUser: $lastUpdateUser
      }
    ) {
      message
      outputData {
        idSurvey
        surveyName
        surveyDescription
        isAnonymous
        setRandomQuestions
        lastUpdateUser
      }
      withError
    }
  }
`;

export const CREATE_USER = gql`
  mutation (
    $rolId: Int!
    $userName: String!
    $firstName: String!
    $lastName: String!
    $userMailBox: String!
    $lobIds: [Int!]!
    $active: Boolean!
    $userEmailAddress: String!
    $cityId: Int!
    $supervisorId: Int
    $isCoMoUser: Boolean
  ) {
    createUser(
      input: {
        roleId: $rolId
        userCcms: $userName
        userCcmsId: 0
        userFirstName: $firstName
        userLastName: $lastName
        userMailBox: $userMailBox
        lobIds: $lobIds
        userEmailAddress: $userEmailAddress
        isActive: $active
        cityId: $cityId
        supervisorId: $supervisorId
        isCoMoUser: $isCoMoUser
      }
    ) {
      userId
    }
  }
`;
export const UPDATE_USER = gql`
  mutation (
    $firstName: String!
    $lastName: String!
    $userEmailAddress: String!
    $newEmailAddress: String!
    $userMailBox: String!
    $userName: String!
    $cityId: Int!
    $roleId: Int!
    $lobIds: [Int!]!
    $active: Boolean!
    $supervisorId: Int
    $isCoMoUser: Boolean
  ) {
    updateUser(
      input: {
        userFirstName: $firstName
        userLastName: $lastName
        userEmailAddress: $userEmailAddress
        newEmailAddress: $newEmailAddress
        userMailBox: $userMailBox
        userCcms: $userName
        cityId: $cityId
        roleId: $roleId
        isActive: $active
        lobIds: $lobIds
        supervisorId: $supervisorId
        isCoMoUser: $isCoMoUser
      }
    ) {
      userId
    }
  }
`;
export const UPDATE_QRUSER = gql`
  mutation ($userId: Int!, $lastUpdateUser: String!, $roleId: Int) {
    updateShowQRUser(
      input: {
        userId: $userId
        lastUpdateUser: $lastUpdateUser
        roleId: $roleId
      }
    )
  }
`;
export const GET_QRUSER = gql`
  mutation {
    showQRUser {
      errors {
        code
        message
      }
      message {
        qrCode
        qrExists
        useTotp
      }
    }
  }
`;

export const LOGIN_USER = gql`
  mutation ($user: String!, $password: String!, $code: String!) {
    userLogin(input: { user: $user, password: $password, code: $code }) {
      loginSuccess
      loginMessage
      qrCode
      qrExists
      useTotp
      accessToken
      refreshToken
    }
  }
`;

export const USERS_SURVEY_ACTIVE_USERS = gql`
  mutation (
    $activeParameter: Boolean!
    $surveyIdParameter: Int!
    $surveyGroupIds: [Int!]
    $emailUser: String!
    $usersIdParameter: [Int!]
  ) {
    usersSurveyActiveUsers(
      activeParameter: $activeParameter
      surveyIdParameter: $surveyIdParameter
      surveyGroupIds: $surveyGroupIds
      emailUser: $emailUser
      usersIdParameter: $usersIdParameter
    )
  }
`;

export const CREATE_USER_SURVEY_GROUP = gql`
  mutation ($input: CreateUserGroupInput!) {
    createUserSurveyGroup(input: $input)
  }
`;
export const BULK_UPLOAD_USERS = gql`
  mutation (
    $file: Upload!
    $createUser: String!
    $authenticationMethodId: Int!
    $clientSiteId: Int!
    $statusId: Int!
    $lobIds: [Int!]
    $rolId: Int!
  ) {
    usersBulkUpload(
      inputFile: $file
      createUser: $createUser
      authenticationMethodId: $authenticationMethodId
      clientSiteId: $clientSiteId
      statusId: $statusId
      lobIds: $lobIds
      rolId: $rolId
    ) {
      message
      isFileOk
    }
  }
`;
export const CREATE_RECURRENCE_CONFIGURATION = gql`
  mutation (
    $recurrenceConfigurationModel: AddTPSurveyRecurrenceConfigurationInput!
  ) {
    createRecurrenceConfiguration(
      recurrenceConfigurationModel: $recurrenceConfigurationModel
    )
  }
`;

export const DELETE_RECURRENCE_CONFIGURATION = gql`
  mutation ($recurrenceConfigurationId: Int!) {
    deleteRecurrenceConfiguration(
      recurrenceConfigurationId: $recurrenceConfigurationId
    )
  }
`;

export const UPDATE_SITE = gql`
  mutation ($input: UpdateSiteInput!) {
    updateSite(input: $input) {
      siteCreated {
        siteId
        siteName
      }
      errors {
        message
        code
      }
    }
  }
`;

export const CREATE_LOB = gql`
  mutation ($lobModel: CreateLobInput!) {
    createLob(lobModel: $lobModel) {
      lobId
      lobName
      lobDescription
    }
  }
`;

export const UPDATE_LOB = gql`
  mutation ($lobModel: UpdateLobInput!) {
    updateLob(lobModel: $lobModel) {
      lobId
      lobName
      lobDescription
    }
  }
`;

export const UPDATE_LOB_STATUS = gql`
  mutation ($lobId: Int!, $enabled: RecordStatusValues!) {
    changeStatusLob(lobId: $lobId, newStatus: $enabled) {
      lobId
      lobName
      lobDescription
      enabled
    }
  }
`;

export const DELETE_LOB = gql`
  mutation ($lobId: Int!, $newStatus: RecordStatusValues!) {
    changeStatusLob(lobId: $lobId, newStatus: $newStatus) {
      lobId
      lobName
      lobDescription
      enabled
    }
  }
`;

export const CREATE_USERS_FEELING = gql`
  mutation (
    $idSmiley: Int!
    $idReason: Int!
    $mailingWellness: Boolean!
    $mailingSupervisor: Boolean!
  ) {
    createUsersFeeling(
      userFeelingModel: {
        idSmiley: $idSmiley
        idReason: $idReason
        mailingWellness: $mailingWellness
        mailingSupervisor: $mailingSupervisor
      }
    ) {
      withError
      message
      outputData {
        idUserFeeling
      }
    }
  }
`;

export const CLONE_SURVEY_GLOBAL = gql`
  mutation ($surveyModel: CloneSurveyGlobalInput!) {
    cloneSurveyGlobal(surveyModel: $surveyModel) {
      message
      withError
      outputData {
        idSurvey
      }
    }
  }
`;

export const CLONE_SURVEY = gql`
  mutation ($surveyModel: ClonepSurveySurveyInput!) {
    cloneSurvey(surveyModel: $surveyModel) {
      message
      withError
      outputData
    }
  }
`;
export const UPDATE_DEPENDENCIES = gql`
  mutation ($dependencies: [DependenciesQuestionInput]) {
    updateQuestionSurveyDependencies(input: $dependencies) {
      outputData
      withError
      message
    }
  }
`;
export const UPDATE_MANY_QUESTIONS = gql`
  mutation ($questions: UpdateMultipleQuestionSurveyInput) {
    updateManyQuestionSurvey(input: $questions) {
      outputData
      withError
      message
    }
  }
`;

export const CHANGE_STATE_SMILEY = gql`
  mutation ($idSmiley: Int!, $newState: RecordState!, $userChange: String) {
    changeStateSmiley(
      idSmiley: $idSmiley
      newState: $newState
      userChange: $userChange
    ) {
      withError
      message
      outputData {
        idSmiley
        smileyFeel
        smileyIdentifier
        source
        recordState
        createUser
        createDate
        lastUpdateUser
        lastUpdateDate
      }
    }
  }
`;

export const MOOD_METER_UPDATE_CONFIGURATION = gql`
  mutation ($intervalDuration: Int!, $recordsPerDay: Int!) {
    moodMeterUpdateConfiguration(
      moodMeterConfigurationModel: {
        intervalDuration: $intervalDuration
        recordsPerDay: $recordsPerDay
      }
    ) {
      withError
      message
      outputData {
        intervalDuration
        recordsPerDay
      }
    }
  }
`;

export const CREATE_MULTIPLE_WELLNESS_MAIL = gql`
  mutation ($idUsers: [Int!], $createUser: String, $idCity: Int!) {
    createMultipleWellnessMail(
      idUsers: $idUsers
      createUser: $createUser
      idCity: $idCity
    ) {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createUser
        createDate
      }
    }
  }
`;

export const DELETE_MULTIPLE_WELLNESS_MAIL = gql`
  mutation ($idUsers: [Int!], $deleteUser: String, $idCity: Int!) {
    deleteMultipleWellnessMail(
      idUsers: $idUsers
      deleteUser: $deleteUser
      idCity: $idCity
    ) {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createUser
        createDate
      }
    }
  }
`;

export const CREATE_MULTIPLE_WELLNESS_MAIL_CATCH_ALL = gql`
  mutation ($idUsers: [Int!], $createUser: String) {
    createMultipleWellnessMailCatchAll(
      idUsers: $idUsers
      createUser: $createUser
    ) {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createUser
        createDate
      }
    }
  }
`;

export const DELETE_MULTIPLE_WELLNESS_MAIL_CATCH_ALL = gql`
  mutation ($idUsers: [Int!], $deleteUser: String) {
    deleteMultipleWellnessMailCatchAll(
      idUsers: $idUsers
      deleteUser: $deleteUser
    ) {
      withError
      message
      outputData {
        idWellnessMail
        idUser
        recordState
        createUser
        createDate
      }
    }
  }
`;

export const CHANGE_STATE_CATEGORY_QUESTION = gql`
  mutation (
    $idCategoryQuestion: Int!
    $newState: RecordState!
    $userChangeState: String
  ) {
    changeStateCategoryQuestion(
      idCategoryQuestion: $idCategoryQuestion
      newState: $newState
      userChangeState: $userChangeState
    ) {
      withError
      message
      outputData {
        idCategoryQuestion
        description
        recordState
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;
export const UPDATE_CATEGORY_QUESTION = gql`
  mutation (
    $idCategoryQuestion: Int!
    $description: String
    $lastUpdateUser: String!
  ) {
    updateCategoryQuestion(
      categoryQuestionModel: {
        idCategoryQuestion: $idCategoryQuestion
        description: $description
        lastUpdateUser: $lastUpdateUser
      }
    ) {
      withError
      message
      outputData {
        idCategoryQuestion
        description
        recordState
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;

export const CHANGE_STATE_CATEGORY_SURVEY = gql`
  mutation (
    $idCategorySurvey: Int!
    $newState: RecordState!
    $userChangeState: String
  ) {
    changeStateCategorySurvey(
      idCategorySurvey: $idCategorySurvey
      newState: $newState
      userChangeState: $userChangeState
    ) {
      withError
      message
      outputData {
        idCategorySurvey
        categoryDescription
        recordState
        createUser
        createDate
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;
export const UPDATE_CATEGORY_SURVEY = gql`
  mutation (
    $idCategorySurvey: Int!
    $categoryDescription: String
    $lastUpdateUser: String!
  ) {
    updateCategorySurvey(
      categorySurveyModel: {
        idCategorySurvey: $idCategorySurvey
        categoryDescription: $categoryDescription
        lastUpdateUser: $lastUpdateUser
      }
    ) {
      withError
      message
      outputData {
        idCategorySurvey
        categoryDescription
        recordState
        createUser
        createDate
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;
export const ADD_FEED_BACK = gql`
  mutation ($surveyId: Int!, $observation: String, $rating: Int!) {
    addFeedback(
      input: { surveyId: $surveyId, observation: $observation, rating: $rating }
    ) {
      withError
      message
      outputData {
        idFeedback
      }
    }
  }
`;

export const MOOD_METER_UPDATE_CONFIGURATION_QUESTION = gql`
  mutation ($questionForUser: String!) {
    moodMeterUpdateConfiguration(
      moodMeterConfigurationModel: { questionForUser: $questionForUser }
    ) {
      withError
      message
      outputData {
        recordsPerDay
        intervalDuration
        questionForUser
      }
    }
  }
`;

export const CREATE_REASON = gql`
  mutation ($reasonDescription: String!, $userCreateReason: String!) {
    createReason(
      reasonDescription: $reasonDescription
      userCreateReason: $userCreateReason
    ) {
      withError
      message
      outputData {
        idReason
        reasonDescription
        recordState
        createDate
        createUser
      }
    }
  }
`;

export const CHANGE_STATE_REASON = gql`
  mutation (
    $idReason: Int!
    $newState: RecordState!
    $userChangeState: String
  ) {
    changeStateReason(
      idReason: $idReason
      newState: $newState
      userChangeState: $userChangeState
    ) {
      withError
      message
      outputData {
        idReason
        reasonDescription
        recordState
        createDate
        createUser
        lastUpdateUser
        lastUpdateDate
      }
    }
  }
`;

export const CREATE_REASON_DETAIL = gql`
  mutation (
    $reasonId: Int!
    $reasonDetailDescription: String!
    $userCreateReasonDetail: String!
  ) {
    createReasonsDetail(
      reasonId: $reasonId
      reasonDetailDescription: $reasonDetailDescription
      userCreateReasonDetail: $userCreateReasonDetail
    ) {
      withError
      message
      outputData {
        idReasonDetail
        idReason
        detailDescription
        recordState
        createDate
        createDate
      }
    }
  }
`;

export const CHANGE_STATE_REASON_DETAIL = gql`
  mutation (
    $idReasonDetail: Int!
    $newState: RecordState!
    $userChangeState: String
  ) {
    changeStateReasonsDetail(
      idReasonDetail: $idReasonDetail
      newState: $newState
      userChangeState: $userChangeState
    ) {
      withError
      message
      outputData {
        idReasonDetail
        idReason
        detailDescription
        recordState
        lastUpdateDate
        lastUpdateUser
      }
    }
  }
`;

export const CREATE_RISK_WORD = gql`
  mutation ($phase: String!, $userCreateRiskWord: String!) {
    createRiskWord(phase: $phase, userCreateRiskWord: $userCreateRiskWord) {
      withError
      message
      outputData {
        idRiskWords
        phrase
        recordState
      }
    }
  }
`;

export const CHANGE_STATE_RISK_WORD = gql`
  mutation (
    $idRiskWork: Int!
    $newState: RecordState!
    $userChangeState: String
  ) {
    changeStateRiskWord(
      idRiskWord: $idRiskWork
      newState: $newState
      userChangeState: $userChangeState
    ) {
      withError
      message
      outputData {
        idRiskWords
        phrase
        recordState
        lastUpdateUser
        lastUpdateDate
      }
    }
  }
`;

export const PARTICIPANT_ATTEND_CHANGE = gql`
  mutation (
    $eventId: Int!
    $userId: Int!
    $participantAttend: String
    $userChange: String!
  ) {
    participantAttendChange(
      eventId: $eventId
      userId: $userId
      participantAttend: $participantAttend
      userChange: $userChange
    ) {
      idEvent
      userId
      attendStatus
      lastUpdateUser
      lastUpdateDate
    }
  }
`;

export const ADD_NEW_EVENT = gql`
  mutation (
    $cityId: Int!
    $countryId: Int!
    $eventCategoryId: Int!
    $eventDescription: String!
    $eventName: String!
    $eventType: WellnessEventType!
    $eventStatus: WellnessEventState!
    $eventUri: String!
    $finishDate: DateTime!
    $groups: [GroupSearchInput!]
    $individualGuests: [Int!]
    $languageId: String!
    $participantIsRequired: Boolean
    $participantsLimit: Int
    $photoUri: String!
    $speakers: [Int!]!
    $startDate: DateTime!
    $recurrence: RecurrenceParamsInput
  ) {
    addNewEvent(
      input: {
        cityId: $cityId
        countryId: $countryId
        eventCategoryId: $eventCategoryId
        eventDescription: $eventDescription
        eventName: $eventName
        eventType: $eventType
        eventStatus: $eventStatus
        eventUri: $eventUri
        finishDate: $finishDate
        groups: $groups
        individualGuests: $individualGuests
        languageId: $languageId
        participantIsRequired: $participantIsRequired
        participantsLimit: $participantsLimit
        photoUri: $photoUri
        speakers: $speakers
        startDate: $startDate
        recurrence: $recurrence
      }
    ) {
      idEvent
      eventName
      description
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation (
    $eventId: Int!
    $cityId: Int!
    $countryId: Int!
    $eventCategoryId: Int!
    $eventDescription: String!
    $eventName: String!
    $eventType: WellnessEventType!
    $eventUri: String!
    $finishDate: DateTime!
    $groups: [GroupSearchInput!]
    $individualGuests: [Int!]
    $languageId: String!
    $participantIsRequired: Boolean
    $participantsLimit: Int
    $photoUri: String!
    $speakers: [Int!]!
    $startDate: DateTime!
  ) {
    updateEvent(
      input: {
        eventId: $eventId
        cityId: $cityId
        countryId: $countryId
        eventCategoryId: $eventCategoryId
        eventDescription: $eventDescription
        eventName: $eventName
        eventType: $eventType
        eventUri: $eventUri
        finishDate: $finishDate
        groups: $groups
        individualGuests: $individualGuests
        languageId: $languageId
        participantIsRequired: $participantIsRequired
        participantsLimit: $participantsLimit
        photoUri: $photoUri
        speakers: $speakers
        startDate: $startDate
      }
    ) {
      idEvent
      eventName
      description
    }
  }
`;

export const UPDATE_RECURRENCE = gql`
  mutation ($eventId: Int!, $recurrence: RecurrenceParamsInput!) {
    updateRecurrence(input: { eventId: $eventId, recurrence: $recurrence })
  }
`;

export const DELETE_RECURRENCE = gql`
  mutation ($eventId: Int!) {
    deleteRecurrence(eventId: $eventId)
  }
`;

export const UPDATE_STATE_EVENT = gql`
  mutation ($eventid: Int!, $newState: String) {
    eventChangeState(eventid: $eventid, newState: $newState) {
      idEvent
      eventName
      eventType
      eventState
      lastUpdateUser
      lastUpdateDate
    }
  }
`;

export const CATEGORY_CHANGE_STATE = gql`
  mutation ($categoryId: Int!, $newRecordState: String) {
    wellnessCategoryChangeState(
      categoryId: $categoryId
      newRecordState: $newRecordState
    ) {
      idCategory
      categoryName
      codeColor
      recordState
      createDate
      createUser
    }
  }
`;

export const CREATE_WELLNESS_CATEGORY = gql`
  mutation ($categoryName: String, $codeColor: String) {
    createWellnessCategory(categoryName: $categoryName, codeColor: $codeColor) {
      idCategory
      categoryName
      codeColor
      recordState
      createDate
      createUser
    }
  }
`;

export const UPDATE_WELLNESS_CATEGORY = gql`
  mutation ($categoryId: Int!, $categoryName: String, $codeColor: String) {
    updateWellnessCategory(
      categoryId: $categoryId
      categoryName: $categoryName
      codeColor: $codeColor
    ) {
      idCategory
      categoryName
      codeColor
      recordState
      createDate
      createUser
    }
  }
`;

export const ADD_WELLNESS_PARTICIPANT_GROUP = gql`
  mutation ($groupName: String!) {
    addWellessParticipantGroup(input: { groupName: $groupName }) {
      idSearchGroup
      name
      idEvent
      groupStatus
    }
  }
`;

export const REMOVE_WELLNESS_PARTICIPANT_GROUP = gql`
  mutation ($groupId: Int!) {
    removeWellnessParticipantGroup(groupId: $groupId) {
      idWellnessGroup
      name
      idEvent
    }
  }
`;

export const DELETE_PARTICIPANT = gql`
  mutation ($eventId: Int!, $userId: Int!) {
    deleteParticipantFromEvent(eventId: $eventId, userId: $userId) {
      userId
    }
  }
`;
export const REGISTER_TO_PUBLIC_EVENT = gql`
  mutation ($eventId: Int!) {
    registerToPublicEvent(eventId: $eventId) {
      idEvent
      attendStatus
    }
  }
`;

export const ADD_SPEAKER = gql`
  mutation ($input: AddSpeakerInput) {
    addSpeaker(input: $input) {
      idSpeaker
    }
  }
`;
export const CREATE_COACH = gql`
  mutation ($input: CreateCoachInput) {
    createCoach(input: $input) {
      idCoach
    }
  }
`;
export const UPDATE_COACH = gql`
  mutation ($input: UpdateCoachInput) {
    updateCoach(input: $input) {
      idCoach
    }
  }
`;
export const UPDATE_WORKING_HOURS_COACH = gql`
  mutation ($input: CreateWorkinghourInput) {
    setWorkours(input: $input) {
      idCoach
    }
  }
`;
export const UPDATE_STATUS_COACH = gql`
  mutation ($coachId: Int!, $status: RecordStateValues!) {
    updateCoachStatus(coachId: $coachId, status: $status) {
      idCoach
    }
  }
`;
export const DELETE_COACH = gql`
  mutation ($coachId: Int!) {
    deleteCoach(coachId: $coachId) {
      idCoach
    }
  }
`;
export const MOVE_TO_CLIENT = gql`
  mutation ($clientId: Int!, $refreshToken: String!) {
    userMoveToClient(clientId: $clientId, refreshToken: $refreshToken) {
      refreshToken
      accessToken
    }
  }
`;

export const UPDATE_SPACE_STATUS = gql`
  mutation ($eventid: Int!, $newState: RecordStateValues!) {
    updateSpaceStatus(eventid: $eventid, newState: $newState) {
      idSpace
      name
      recordState
    }
  }
`;

export const UPDATE_GAME_STATUS = gql`
  mutation ($gameId: Int!, $newStatus: RecordStateValues!) {
    changeGameStatus(input: { newStatus: $newStatus, gameId: $gameId }) {
      status
    }
  }
`;

export const CREATE_SPACE = gql`
  mutation (
    $name: String!
    $description: String
    $coverImageSrc: String
    $topic: String!
    $startDate: DateTime!
    $finishDate: DateTime!
    $url: String!
    $idCity: Int!
    $usersRegistered: [UsersSpaceInput]
    $groupRegistered: [GroupUsersSpaceInput]
  ) {
    createSpace(
      addSpaceInput: {
        name: $name
        description: $description
        coverImageSrc: $coverImageSrc
        topic: $topic
        startDate: $startDate
        finishDate: $finishDate
        url: $url
        idCity: $idCity
        usersRegistered: $usersRegistered
        groupRegistered: $groupRegistered
      }
    ) {
      idSpace
    }
  }
`;
export const CREATE_GAME = gql`
  mutation (
    $name: String!
    $topic: String!
    $startDate: DateTime!
    $endDate: DateTime!
    $url: String!
    $description: String!
    $coverImage: String
    $individualUsers: [Int!]
    $gameGroups: [GameGroupInput!]
  ) {
    addGame(
      input: {
        name: $name
        topic: $topic
        startDate: $startDate
        endDate: $endDate
        url: $url
        description: $description
        coverImage: $coverImage
        individualUsers: $individualUsers
        gameGroups: $gameGroups
      }
    ) {
      name
    }
  }
`;
export const UPDATE_GAME = gql`
  mutation (
    $gameId: Int!
    $name: String
    $description: String
    $coverImage: String
    $topic: String
    $startDate: DateTime
    $endDate: DateTime
    $url: String
    $individualUsers: [Int!]
    $gameGroups: [GameGroupInput!]
  ) {
    updateGame(
      input: {
        gameId: $gameId
        name: $name
        description: $description
        coverImage: $coverImage
        topic: $topic
        startDate: $startDate
        endDate: $endDate
        url: $url
        individualUsers: $individualUsers
        gameGroups: $gameGroups
      }
    ) {
      name
    }
  }
`;

export const UPDATE_SPACE = gql`
  mutation (
    $idSpace: Int!
    $name: String
    $description: String
    $coverImageSrc: String
    $topic: String
    $startDate: DateTime
    $finishDate: DateTime
    $url: String
    $idCity: Int
    $usersRegistered: [UsersSpaceInput]
    $groupRegistered: [GroupUsersSpaceInput]
  ) {
    updateSpace(
      editSpaceInput: {
        idSpace: $idSpace
        name: $name
        description: $description
        coverImageSrc: $coverImageSrc
        topic: $topic
        startDate: $startDate
        finishDate: $finishDate
        url: $url
        idCity: $idCity
        usersRegistered: $usersRegistered
        groupRegistered: $groupRegistered
      }
    ) {
      idSpace
    }
  }
`;

export const UPDATE_APPROVER = gql`
  mutation (
    $approverId: Int!
    $addUserIds: [Int!]
    $addGroups: [GroupUsersApproverInput]
    $removeUsersIds: [Int!]
    $removeGroupsIds: [Int!]
  ) {
    updateApprover(
      approverId: $approverId
      addUserIds: $addUserIds
      addGroups: $addGroups
      removeUsersIds: $removeUsersIds
      removeGroupsIds: $removeGroupsIds
    ) {
      withError
      message
      outputData {
        users {
          userId
          userName
        }
        groups {
          groupId
          groupName
        }
      }
    }
  }
`;

export const CREATE_APPROVER_COMMENT = gql`
  mutation ($idApprover: Int!, $idSurvey: Int!, $comment: String!) {
    createApproverComment(
      approverCommentInput: {
        idApprover: $idApprover
        idSurvey: $idSurvey
        comment: $comment
      }
    ) {
      withError
      message
      outputData {
        idApproverComment
        idApprover
        idSurvey
        comment
        solved
        createDate
        createUser
      }
    }
  }
`;

export const UPDATE_APPROVER_COMMENT = gql`
  mutation ($idApproverComment: Int!, $comment: String, $solved: Boolean) {
    updateApproverComment(
      idApproverComment: $idApproverComment
      comment: $comment
      solved: $solved
    ) {
      withError
      message
      outputData {
        idApproverComment
        idApprover
        idSurvey
        comment
        solved
        createDate
        createUser
      }
    }
  }
`;

export const EMAIL_TEMPLATE_CHANGE_STATE = gql`
  mutation ($emailTemplateId: Int!, $newRecordState: RecordStateValues!) {
    emailTemplateChangeState(
      emailTemplateId: $emailTemplateId
      newRecordState: $newRecordState
    ) {
      idEmailTemplate
      name
      description
      recordState
      lastUpdateUser
      lastUpdateDate
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation (
    $idEmailTemplate: Int!
    $name: String
    $description: String
    $emailSubject: String
    $emailBody: String
    $allCountries: Boolean!
    $idCountry: Int
    $emailTemplateCode: String
  ) {
    updateEmailTemplate(
      updateEmailParameter: {
        idEmailTemplate: $idEmailTemplate
        name: $name
        description: $description
        emailSubject: $emailSubject
        emailBody: $emailBody
        allCountries: $allCountries
        idCountry: $idCountry
        emailTemplateCode: $emailTemplateCode
      }
    ) {
      idEmailTemplate
      name
      description
      emailSubject
      emailBody
    }
  }
`;
export const SAVE_TO_BANK = gql`
  mutation ($idQuestionSurvey: Int!) {
    saveToBank(input: { idQuestionSurvey: $idQuestionSurvey }) {
      message
      withError
      outputData
    }
  }
`;
export const ADD_QUESTION_BANK_TO_SURVEY = gql`
  mutation ($questionSurveyIds: [Int!]!, $idSurvey: Int!) {
    questionBankToSurvey(
      input: { questionSurveyIds: $questionSurveyIds, idSurvey: $idSurvey }
    ) {
      message
      outputData {
        idQuestionSurvey
        idQuestionNavigation {
          nameQuestion
        }
        jsonConfiguration
      }
      withError
    }
  }
`;
export const SAVE_SURVEY_AS_TEMPLATE = gql`
  mutation ($surveyId: Int!, $templateName: String!) {
    saveAsTemplate(
      input: { surveyId: $surveyId, templateName: $templateName }
    ) {
      message
      withError
    }
  }
`;

export const APPLY_SURVEY_TEMPLATE = gql`
  mutation ($templateId: Int!, $surveyId: Int!) {
    applyTemplate(input: { templateId: $templateId, surveyId: $surveyId }) {
      message
      withError
    }
  }
`;

export const CHECK_ATTENDANCE = gql`
  mutation ($eventId: Int!, $userId: [Int!]!, $attendanceCheck: Boolean!) {
    checkAttendance(
      eventId: $eventId
      userIds: $userId
      attendanceCheck: $attendanceCheck
    )
  }
`;

export const LOG_OUT_USER = gql`
  mutation ($refreshToken: String!) {
    userLogOut(refreshToken: $refreshToken)
  }
`;

export const REFRESH_TOKEN = gql`
  mutation ($refreshToken: String!) {
    userRefreshToken(refreshToken: $refreshToken) {
      loginSuccess
      loginMessage
      accessToken
      refreshToken
    }
  }
`;

export const CREATE_SURVEY_FOR_EVENT = gql`
  mutation (
    $guestList: [Int!]
    $surveyName: String
    $surveyDescription: String
  ) {
    createSurveyForWellnessEvent(
      input: {
        guessList: $guestList
        surveyName: $surveyName
        surveyDescription: $surveyDescription
      }
    ) {
      message
      outputData
      withError
    }
  }
`;

export const JOIN_EVENT_WITH_SURVEY = gql`
  mutation ($eventId: Int!, $surveyId: Int!) {
    joinEventWithSurvey(eventId: $eventId, surveyId: $surveyId)
  }
`;
export const CREATE_EVENT_FEEDBACK = gql`
  mutation ($rating: Int!, $observations: String, $idEvent: Int!) {
    createEventFeedBack(
      eventFeedBackParameter: {
        rating: $rating
        observations: $observations
        idEvent: $idEvent
      }
    ) {
      idEventFeedback
      idEvent
      idUser
      rating
      observations
      createDate
    }
  }
`;

export const CREATE_FORM = gql`
  mutation ($name: String!, $description: String!) {
    createForm(
      inputParameter: {
        name: $name
        description: $description
        idCity: 0
        idLobs: []
      }
    ) {
      idForm
      name
      description
    }
  }
`;

export const CHANGE_STATUS_FORM = gql`
  mutation ($idForm: Int!, $newFormStatus: RecordStatusValues!) {
    changeStatusForm(idForm: $idForm, newFormStatus: $newFormStatus) {
      idForm
      name
      description
      recordStatus
    }
  }
`;

export const UPDATE_FORM_CONFIG = gql`
  mutation (
    $idForm: Int!
    $name: String!
    $description: String!
    $idCity: Int!
    $idLobs: [Int!]!
    $jsonConfiguration: String!
  ) {
    updateForm(
      inputParameter: {
        idForm: $idForm
        name: $name
        description: $description
        idCity: $idCity
        idLobs: $idLobs
        jsonConfiguration: $jsonConfiguration
      }
    ) {
      idForm
      name
      description
    }
  }
`;
export const CREATE_FORM_QUESTION = gql`
  mutation (
    $idForm: Int!
    $questionTitle: String!
    $questionType: QuestionTypeValues!
    $jsonConfiguration: String!
    $isMandatory: Boolean!
    $questionOrder: Int!
  ) {
    createFormQuestion(
      inputParameter: {
        idForm: $idForm
        questionTitle: $questionTitle
        questionType: $questionType
        jsonConfiguration: $jsonConfiguration
        isMandatory: $isMandatory
        questionOrder: $questionOrder
      }
    ) {
      idForm
      questionTitle
      questionType
      questionOrder
      idQuestionForm
    }
  }
`;

export const UPDATE_FORM_QUESTION = gql`
  mutation (
    $idQuestionForm: Int!
    $questionTitle: String
    $questionType: QuestionTypeValues
    $isMandatory: Boolean
    $questionOrder: Int
    $jsonConfiguration: String
  ) {
    updateFormQuestion(
      inputParameter: {
        idQuestionForm: $idQuestionForm
        questionTitle: $questionTitle
        questionType: $questionType
        isMandatory: $isMandatory
        questionOrder: $questionOrder
        jsonConfiguration: $jsonConfiguration
      }
    ) {
      idQuestionForm
      idForm
      questionTitle
      questionType
    }
  }
`;
export const UPDATE_FORM_QUESTION_STATUS = gql`
  mutation (
    $idFormQuestion: Int!
    $newFormQuestionStatus: RecordStatusValues!
  ) {
    changeStatusFormQuestion(
      idFormQuestion: $idFormQuestion
      newFormQuestionStatus: $newFormQuestionStatus
    ) {
      idForm
      idQuestionForm
      questionTitle
      questionType
      recordStatus
    }
  }
`;

export const CREATE_CASE = gql`
  mutation (
    $idForm: Int!
    $caseAnswersParameter: [CreateQuestionAnswerInput!]!
    $highPriority: Boolean!
    $highPriorityReasons: String
  ) {
    createCase(
      inputParameter: {
        idForm: $idForm
        highPriority: $highPriority
        highPriorityReasons: $highPriorityReasons
        caseAnswersParameter: $caseAnswersParameter
      }
    ) {
      idCase
      idForm
      status
      createUser
      createDate
    }
  }
`;

export const CHANGE_STATUS_CASE_COMMENT = gql`
  mutation ($idCaseComment: Int!, $newCommentStatus: RecordStatusValues!) {
    changeStatusCaseComment(
      idCaseComment: $idCaseComment
      newCommentStatus: $newCommentStatus
    ) {
      idCaseComment
      idCase
      comment
      recordStatus
      createUser
      createDate
    }
  }
`;

export const CREATE_CASE_COMMENT = gql`
  mutation ($idCase: Int!, $comment: String!) {
    createCaseComment(inputParameter: { idCase: $idCase, comment: $comment }) {
      idCaseComment
      idCase
      comment
      isOwnerCase
      smiley
      ilike
      createUser
      createDate
    }
  }
`;

export const UPDATE_CASE_COMMENT = gql`
  mutation (
    $idCaseComment: Int!
    $comment: String!
    $smiley: String
    $ilike: String
  ) {
    updateCaseComment(
      inputParameter: {
        idCaseComment: $idCaseComment
        comment: $comment
        smiley: $smiley
        ilike: $ilike
      }
    ) {
      idCaseComment
      idCase
      comment
      smiley
      ilike
    }
  }
`;

export const CHANGE_STATUS_CASE = gql`
  mutation ($caseId: Int!, $newCaseSatus: CaseStatusValues) {
    changeStatusCase(caseId: $caseId, newCaseSatus: $newCaseSatus) {
      idCase
      status
    }
  }
`;

export const CREATE_POLICY = gql`
  mutation (
    $mainPolicyName: String!
    $countryId: Int!
    $subPolicies: [CreateSubPolicyInput!]!
  ) {
    createPolicy(
      inputParameter: {
        mainPolicyName: $mainPolicyName
        countryId: $countryId
        subPolicies: $subPolicies
      }
    ) {
      idMainPolicy
      policyName
      recordStatus
      createUser
      createDate
    }
  }
`;
export const CREATE_QUEUE = gql`
  mutation ($queueName: String!, $lobIds: [Int!]!) {
    createQueue(inputParameter: { queueName: $queueName, lobIds: $lobIds }) {
      idQueue
    }
  }
`;

export const CHANGE_POLICY_STATUS = gql`
  mutation ($policyId: Int!, $newPolicyStatus: RecordStatusValues!) {
    changeStatusMainPolicy(
      policyId: $policyId
      newPolicyStatus: $newPolicyStatus
    ) {
      idMainPolicy
      policyName
      recordStatus
    }
  }
`;
export const CHANGE_SUB_POLICY_STATUS = gql`
  mutation ($policyId: Int!, $newPolicyStatus: RecordStatusValues!) {
    changeStatusSubPolicy(
      policyId: $policyId
      newPolicyStatus: $newPolicyStatus
    ) {
      idSubPolicy
      subPolicyName
      recordStatus
    }
  }
`;

export const UPDATE_MAIN_POLICY = gql`
  mutation ($idPolicy: Int!, $policyName: String!) {
    updateMainPolicy(
      inputParameter: { idPolicy: $idPolicy, policyName: $policyName }
    ) {
      idMainPolicy
    }
  }
`;

export const UPDATE_SUB_POLICY = gql`
  mutation ($idPolicy: Int!, $policyName: String!, $lobIds: [Int!]!) {
    updateSubPolicy(
      inputParameter: {
        idSubPolicy: $idPolicy
        subPolicyName: $policyName
        lobIds: $lobIds
      }
    ) {
      idSubPolicy
    }
  }
`;
export const CREATE_SUB_POLICY = gql`
  mutation ($mainPolicyId: Int!, $policyName: String!, $lobIds: [Int!]!) {
    createSubPolicy(
      inputParameter: {
        mainPolicyId: $mainPolicyId
        subPolicyName: $policyName
        lobIds: $lobIds
      }
    ) {
      idSubPolicy
    }
  }
`;

export const CHANGE_QUEUE_STATUS = gql`
  mutation ($queueId: Int!, $newQueueStatus: RecordStatusValues!) {
    changeStatusQueue(queueId: $queueId, newQueueStatus: $newQueueStatus) {
      idQueue
      queueName
      recordStatus
    }
  }
`;

export const UPDATE_QUEUE = gql`
  mutation ($idQueue: Int!, $queueName: String!, $lobIds: [Int!]!) {
    updateQueue(
      inputParameter: {
        idQueue: $idQueue
        queueName: $queueName
        lobIds: $lobIds
      }
    ) {
      idQueue
    }
  }
`;
export const UPDATE_ICE_CONTACT_FOR_CITY = gql`
  mutation ($cityId: Int!, $userIds: [Int!]!) {
    updateIceContactByCity(cityId: $cityId, userIds: $userIds) {
      userId
      firstName
      lastName
      emailAddress
    }
  }
`;

export const CREATE_ADDITIONAL_DATA_BY_CASE_ID = gql`
  mutation ($caseId: Int!, $answers: [AdditionalDataAnswerInput!]!) {
    createAdditionalDataByCaseId(
      addAdditionalDataInput: { caseId: $caseId, answers: $answers }
    )
  }
`;

export const CREATE_INSTANT_MESSAGE = gql`
  mutation ($message: String!) {
    createInstantMessage(message: $message) {
      instanceMessageId
      message
      status
    }
  }
`;

export const UPDATE_INSTANT_MESSAGE = gql`
  mutation ($instantMessageId: Int!, $message: String!) {
    updateInstantMessage(
      instantMessageId: $instantMessageId
      message: $message
    ) {
      instanceMessageId
      message
      status
    }
  }
`;
export const DELETE_INSTANT_MESSAGE = gql`
  mutation ($instantMessageId: Int!) {
    deleteInstantMessage(instantMessageId: $instantMessageId) {
      instanceMessageId
      status
    }
  }
`;
export const SEND_ICE_ALERT = gql`
  mutation {
    sendIceAlert
  }
`;

export const SEND_ICE_ALERT_RESPONSE = gql`
  mutation ($idIceRequest: Int!, $instanceMessageIds: [Int!]!) {
    sendIceAlertResponse(
      idIceRequest: $idIceRequest
      instanceMessageIds: $instanceMessageIds
    ) {
      idIceResponse
      idIceResponse
      idUserReponse
      wellnessIceResponseMessages {
        id
        idIceResponse
        instantMessageId
      }
    }
  }
`;

export const CLOSE_ICE_ALERT_REQUEST = gql`
  mutation ($idIceRequest: Int!) {
    closeIceAlertRequest(idIceRequest: $idIceRequest) {
      iceRequestId
      interactionUserId
      wellnessLeadUserId
      createdDate
      closeDate
    }
  }
`;

export const ADD_REMOVE_ADDITIONAL_DATA_LIST = gql`
  mutation ($formId: Int!, $additionalDataLists: [AddAddtionalDataInput!]!) {
    addRemoveAdditionalDataList(
      input: { formId: $formId, additionalDataLists: $additionalDataLists }
    )
  }
`;

export const UPDATE_IS_MANDATORY_LIST = gql`
  mutation ($formId: Int!, $isMandatory: Boolean!, $listId: Int!) {
    updateIsMandatoryList(
      input: { formId: $formId, isMandatory: $isMandatory, listId: $listId }
    )
  }
`;

export const ADD_REMOVE_ADDITIONAL_DATA_FILE = gql`
  mutation ($formId: Int!) {
    addRemoveAdditionalDataFile(formId: $formId)
  }
`;

export const UPDATE_IS_MANDATORY_FILE = gql`
  mutation ($formId: Int!, $isMandatory: Boolean!) {
    updateIsMandatoryFile(input: { formId: $formId, isMandatory: $isMandatory })
  }
`;

export const ADD_UPDATE_ADDITIONAL_DATA_OPEN_TEXT = gql`
  mutation (
    $additionalDataQuestionOpenTextId: Int
    $formId: Int!
    $isMandatory: Boolean!
    $jsonConfiguration: String!
    $title: String!
  ) {
    addUpdateAdditionalDataOpenText(
      input: {
        additionalDataQuestionOpenTextId: $additionalDataQuestionOpenTextId
        formId: $formId
        isMandatory: $isMandatory
        jsonConfiguration: $jsonConfiguration
        title: $title
      }
    ) {
      idFormAdditionalDataQuestion
    }
  }
`;

export const DELETE_ADDITIONAL_DATA_OPEN_TEXT = gql`
  mutation ($openTextQuestionId: Int!) {
    deleteAdditionalDataOpenText(openTextQuestionId: $openTextQuestionId)
  }
`;

export const UPDATE_USER_STATUS = gql`
  mutation ($newStatusId: RecordStatusValues!, $userEmailAddress: String!) {
    changeStatusUser(
      newUserStatus: $newStatusId
      userEmailAddress: $userEmailAddress
    ) {
      userId
    }
  }
`;

export const UPDATE_TP_ID = gql`
  mutation ($newTpid: String!) {
    updateTpId(newTpid: $newTpid) {
      message
      outputData {
        userId
        tpid
      }
      withError
    }
  }
`;

export const CREATE_LOCATION = gql`
  mutation ($cityId: Int!) {
    createLocation(cityId: $cityId) {
      countryId
      countryName
      cityId
      cityName
      createUser
      createDate
      enabled
    }
  }
`;
export const CHANGE_LOCATION_STATUS = gql`
  mutation ($cityId: Int!, $newStatus: RecordStatusValues!) {
    changeStatusLocation(cityId: $cityId, newStatus: $newStatus) {
      countryId
      countryName
      cityId
      cityName
      createUser
      createDate
      enabled
    }
  }
`;

export const ACK_MOOD_METER_REQUESTS = gql`
  mutation ($idMoodMeterRequest: Int!) {
    updateMoodMeterRequest(idMoodMeterRequest: $idMoodMeterRequest)
  }
`;

export const CLOSE_MOOD_METER_REQUESTS = gql`
  mutation ($idMoodMeterRequest: Int!) {
    closeMoodMeterRequest(idMoodMeterRequest: $idMoodMeterRequest) {
      message
      outputData
      withError
    }
  }
`;
export const SEND_MOOD_INSTANT_MESSAGE = gql`
  mutation ($idMoodRequest: Int!, $instanceMessageIds: [Int!]!) {
    sendMoodRequestResponse(
      idMoodRequest: $idMoodRequest
      instanceMessageIds: $instanceMessageIds
    ) {
      message
      outputData {
        idMoodResponse
        idUserReponse
        tpsurveyMoodResponseMessages {
          id
          instantMessageId
        }
      }
      withError
    }
  }
`;

export const ACK_ICE_REQUESTS = gql`
  mutation ($idIceRequest: Int!) {
    updateIceAlertRequest(idIceRequest: $idIceRequest)
  }
`;

export const UPDATE_COUNSELLING_THEME = gql`
  mutation ($eventId: Int!, $counsellingThemeIds: [Int!]!) {
    updateCoachEventCounsellingTheme(
      eventId: $eventId
      counsellingThemeIds: $counsellingThemeIds
    ) {
      idEvent
      wellnessEventsCounsellingThemes {
        idCounsellingTheme
        idCounsellingThemeNavigation {
          themeName
        }
      }
    }
  }
`;

export const CREATE_THEME = gql`
  mutation ($themeName: String!) {
    createCounsellingTheme(
      input: { themeName: $themeName, jsonConfiguration: "" }
    ) {
      idCounsellingTheme
    }
  }
`;

export const UPDATE_THEME = gql`
  mutation ($counsellingThemeId: Int!, $themeName: String!) {
    updateCounsellingTheme(
      input: {
        counsellingThemeId: $counsellingThemeId
        themeName: $themeName
        jsonConfiguration: ""
      }
    ) {
      idCounsellingTheme
      themeName
    }
  }
`;

export const CHANGE_THEME_STATUS = gql`
  mutation ($counsellingThemeId: Int!, $newStatus: RecordStateValues!) {
    changeStatusCounsellingTheme(
      counsellingThemeId: $counsellingThemeId
      newStatus: $newStatus
    ) {
      idCounsellingTheme
      themeName
      recordState
    }
  }
`;

// ADD NEW ACCOUNTS
export const CREATE_USER_IN_CLIENT = gql`
  mutation (
    $clientId: Int!
    $userTpId: String!
    $roleId: Int!
    $cityId: Int!
    $isCoMoUser: Boolean
    $supervisorId: Int
    $isActive: Boolean!
    $lobIds: [Int!]!
  ) {
    createUserInClient(
      input: {
        clientId: $clientId
        userTpId: $userTpId
        roleId: $roleId
        cityId: $cityId
        isCoMoUser: $isCoMoUser
        supervisorId: $supervisorId
        isActive: $isActive
        lobIds: $lobIds
      }
    ) {
      userId
      userFirstName
      userLastName
      userTpId
      userEmail
      enabled
      isCoMoUser
      location {
        cityId
        cityName
        clientName
        countryId
        countryName
      }
      lobs {
        lobId
        lobName
      }
    }
  }
`;

export const UPDATE_USER_CLIENT = gql`
  mutation (
    $clientId: Int!
    $userTpId: String!
    $roleId: Int!
    $cityId: Int!
    $isCoMoUser: Boolean
    $supervisorId: Int
    $isActive: Boolean!
    $lobIds: [Int!]!
  ) {
    updateUserInClient(
      input: {
        clientId: $clientId
        userTpId: $userTpId
        roleId: $roleId
        cityId: $cityId
        isCoMoUser: $isCoMoUser
        supervisorId: $supervisorId
        isActive: $isActive
        lobIds: $lobIds
      }
    ) {
      userId
      userFirstName
      userLastName
      userTpId
      userEmail
      enabled
      isCoMoUser
      location {
        cityId
        cityName
        clientName
        countryId
        countryName
      }
      lobs {
        lobId
        lobName
      }
    }
  }
`;

export const CHANGE_STATUS_USER_BY_CLIENT_ID = gql`
  mutation (
    $userEmailAddress: String!
    $newUserStatus: RecordStatusValues!
    $clientId: Int!
  ) {
    changeStatusUser(
      userEmailAddress: $userEmailAddress
      newUserStatus: $newUserStatus
      clientId: $clientId
    ) {
      userId
      userFirstName
      userLastName
      userTpId
      userEmail
      enabled
      location {
        cityId
        cityName
        clientName
        countryId
        countryName
      }
      lobs {
        lobId
        lobName
      }
    }
  }
`;

export const UPDATE_MY_PROFILE_PICTURE = gql`
  mutation ($avatarType: AvatarTypeValues!, $jsonConfig: String, $imageName: String) {
    updateMyProfilePicture(
      input: {
        avatarType: $avatarType
        jsonConfig: $jsonConfig
        imageName: $imageName
      }
    ) {
      avatarType
      jsonConfig
      imageName
    }
  }
`;
